import React from 'react';
import { Tag, Tooltip } from "antd";
import styled from 'styled-components';
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const TooltipText = styled.div`
  text-align: center;
  font-size: 12px;
  max-width: 207px;
`;

export const renderSelfAvailabilityTag = (t, val) => (
  <Tooltip title={t(!val ? 'The counterparty itself has not shared KYC information.' : 'KYC information from the counterparty itself is included in this analysis.')}>
    <div className="availability-container">
      <Tag
        color={val ? 'green' : 'red'}
        icon={val ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
      >
        {t(val ? 'Self-assessment Available' : 'Self-assessment Unavailable')}
      </Tag>
    </div>
  </Tooltip>
);

export const renderAvailabilityTag = (t, val) => (
  <div className="availability-container">
    <Tooltip title={(
      <TooltipText>
        {t(
          val
            ? 'The counterparty has provided information on its supply chain risk management systems.'
            : 'The counterparty has not provided information on its supply chain risk management systems.')}
      </TooltipText>
    )}>
      <Tag
        color={val ? 'green' : 'red'}
        icon={val ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
      >
        {t(val ? 'Available' : 'Unavailable')}
      </Tag>
    </Tooltip>
  </div>
);

export const placeholder = '--';
